import { IonButton, useIonToast } from '@ionic/react';
import { Trans, t } from '@lingui/macro';
import React, { useCallback, useState } from 'react';

import LoadingButton from '../../../components/loadingbutton/LoadingButton';
import InterventionPage from '../../../components/page/InterventionPage';
import { IInstallationRouteProps } from '../../../interfaces/IRoute';
import { ESPProvisionManager } from '../../../provisioning/ESPProvisionManager';
import { trackActionsRequest } from '../../../store/Requests';
import { useCustomRouter } from '../../../utils/hooks/useCustomRouter';

enum LoadingType {
    EndProvisioning = 'EndProvisioning',
}

const Maintenance: React.FC<IInstallationRouteProps> = ({ match }) => {
    const provisionManager = ESPProvisionManager.getInstance();
    const router = useCustomRouter();
    const jobId = +match.params.jobId;
    const [presentToast] = useIonToast();
    const [loadingType, setLoadingType] = useState<LoadingType | undefined>(
        undefined
    );

    const onEndProvisioningHandler = useCallback(async () => {
        setLoadingType(LoadingType.EndProvisioning);
        try {
            await provisionManager.getEspDevice().endMacProvisioning();
            await provisionManager.getEspDevice().disconnectDevice();
            trackActionsRequest('end_provisioning');
            router.push(`/${jobId}/installation/mesh/status`, 'forward');
        } catch (e) {
            const error = e as Error;
            presentToast({
                message: error.message,
                duration: 5000,
                color: 'danger',
                buttons: [
                    {
                        text: t`Dismiss`,
                        role: 'cancel',
                    },
                ],
            });
        }
        setLoadingType(undefined);
    }, [jobId, presentToast, provisionManager, router]);

    return (
        <InterventionPage title={t`Mesh`} withPadding>
            <p>
                <Trans>
                    Choose maintenance operation for{' '}
                    {ESPProvisionManager.getInstance()
                        .getEspDevice()
                        .getDeviceName()}
                </Trans>
            </p>
            <IonButton
                routerLink={`/${jobId}/installation/mesh/select-network`}
                routerDirection="forward"
                expand="block"
                className="ion-margin-top"
            >
                <Trans>Update WiFi credentials</Trans>
            </IonButton>
            <IonButton
                routerLink={`/${jobId}/installation/mesh/provisioning-macs`}
                routerDirection="forward"
                expand="block"
                className="ion-margin-top"
            >
                <Trans>Add device(s) to mesh</Trans>
            </IonButton>
            <LoadingButton
                loading={loadingType === LoadingType.EndProvisioning}
                onClick={onEndProvisioningHandler}
                expand="block"
                className="ion-margin-top"
            >
                <Trans>Exit maintenance</Trans>
            </LoadingButton>
        </InterventionPage>
    );
};

export default Maintenance;
